<div class="modal-header" *ngIf="!isPage">
  <h2 class="modal-title">
    {{ title | translate }}
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>

<div [ngClass]="isPage ? 'sale-item-create-page' : 'modal-body'">
  <div
    class="row justify-center"
    [hidden]="!(saleItemCreate == null && saleId)"
  >
    <div class="col-lg-4">
      <button
        class="btn btn-ghost-primary text-body w-100 h-100 py-3 rounded border"
        (click)="onClickAddSaleItem()"
        type="button"
      >
        <span class="m-3 d-block">
          <i
            role="img"
            class="fa fa-shopping-cart fa-2x text-primary"
            aria-hidden="true"
          ></i>
        </span>

        <span class="h2 text-dark m-3 d-block">
          {{ 'saleModule.addSaleItems' | translate }}
        </span>
      </button>
    </div>
    <div class="col-lg-4" *ngIf="isMultiDayEnabled">
      <button
        class="w-100 h-100 py-3 rounded border btn btn-ghost-primary text-body"
        *ngIf="isMultiDayEnabled"
        (click)="onClickAddMultiSaleItem()"
        type="button"
      >
        <span class="m-3 d-block">
          <i
            role="img"
            class="fa fa-shopping-cart fa-2x text-primary"
            aria-hidden="true"
          ></i>
        </span>
        <span class="h2 text-dark m-3 d-block">
          {{ 'bookingModule.addMultiSaleItems' | translate }}
        </span>
      </button>
    </div>
    <div class="col-lg-4">
      <button
        class="w-100 h-100 py-3 rounded border btn btn-ghost-primary text-body"
        (click)="onClickAddBooking()"
        type="button"
      >
        <span class="m-3 d-block">
          <i
            role="img"
            class="fa fa-calendar-alt fa-2x text-primary"
            aria-hidden="true"
          ></i>
        </span>

        <span class="h2 text-dark m-3 d-block">
          {{ 'bookingModule.addBooking' | translate }}
        </span>
      </button>
    </div>
  </div>

  <sale-item-form-create
    *ngIf="activeMode === 'single'"
    [customerCategoryId]="customerCategoryId"
    [saleId]="saleId"
    [typeProduct]="title"
    (onSubmit)="onSubmit($event)"
    (formStateChange)="onFormStateChange($event)"
    [loading]="loading"
  >
  </sale-item-form-create>
  <subs-sale-item-form-create
    *ngIf="activeMode === 'subscription'"
    [selectedCustomerPersonId]="selectedCustomerPersonId"
    [customerCategoryId]="customerCategoryId"
    [saleId]="saleId"
    [typeProduct]="title"
    (onSubmit)="onSubmitSubscription($event)"
    (formStateChange)="onFormStateChange($event)"
    [loading]="loading"
  >
  </subs-sale-item-form-create>
  <rental-sale-item-form-create
    *ngIf="activeMode === 'rental'"
    [customerCategoryId]="customerCategoryId"
    (onSubmit)="onSubmitRental($event)"
    (formStateChange)="onFormStateChange($event)"
    [loading]="loading"
  >
  </rental-sale-item-form-create>
  <booking-multi-day
    *ngIf="activeMode === 'multiple' && isMultiDayEnabled"
    (onSubmit)="onSubmitMulti($event)"
    [loading]="loading"
  ></booking-multi-day>
</div>

<div class="modal-footer" *ngIf="shouldShowFooterSaveButton">
  <button
    data-test-id="sale-create-form-save-button"
    class="btn btn-primary"
    type="button"
    [disabled]="isSaveButtonDisabled"
    (click)="onClickSave()"
  >
    {{ saveButtonLabelKey | translate }}
    <ng-container *ngIf="currentFormState?.submitLabelSuffixKey">
      {{ currentFormState?.submitLabelSuffixKey | translate }}
    </ng-container>
  </button>
</div>
